module.exports = __webpack_public_path__ + "assets/img/11.902f36f3.png";